export const GET_INSTANCE_TEMPLATE_LIST="GET_INSTANCE_TEMPLATE_LIST";
export const ADD_INSTANCE_TEMPLATE="ADD_INSTANCE_TEMPLATE";
export const UPDATE_INSTANCE_TEMPLATE="UPDATE_INSTANCE_TEMPLATE";
export const DELETE_INSTANCE_TEMPLATE="DELETE_INSTANCE_TEMPLATE";
export const HIDE_LOADING="HIDE_LOADING";
export const SHOW_LOADING="SHOW_LOADING";
export const INSTANCE_TEMPLATE_LIST="INSTANCE_TEMPLATE_LIST";
export const SET_INSTANCE_ADD_EDIT="SET_ADD_EDIT";
export const INSTANCE_TEMPLATE_MESSAGE="INSTANCE_TEMPLATE_MESSAGE";
export const GET_INSTANCE_TEMPLATE_PAGE_DRAFT_LIST="GET_INSTANCE_TEMPLATE_PAGE_DRAFT_LIST";
export const ADD_INSTANCE_TEMPLATE_PAGE_DRAFT="ADD_INSTANCE_TEMPLATE_PAGE_DRAFT";
export const UPDATE_INSTANCE_TEMPLATE_PAGE_DRAFT="UPDATE_INSTANCE_TEMPLATE_PAGE_DRAFT";
export const DELETE_INSTANCE_TEMPLATE_PAGE_DRAFT="DELETE_INSTANCE_TEMPLATE_PAGE_DRAFT";
export const INSTANCE_TEMPLATE_PAGE_DRAFT_LIST="INSTANCE_TEMPLATE_PAGE_DRAFT_LIST";
export const INSTANCE_TEMPLATE_PAGE_DRAFT_MESSAGE="INSTANCE_TEMPLATE_PAGE_DRAFT_MESSAGE";
export const INSTANCE_TEMPLATE_PAGE_LIST="INSTANCE_TEMPLATE_PAGE_LIST";
export const TAB_VALUE="TAB_VALUE";